import React, { Component } from 'react'
import MenuSider from '../../../components/MenuSider'
import ScrollToTop from '../../../components/ScrollToTop'
import { Popconfirm, Form, Input, Select, Button, Table, InputNumber, Switch, Tag, Spin } from 'antd';
import './SystemManagement.css';
import { Constants, Odata_Url } from '../../../Constants/Constants'
import axios from 'axios'

const Option = Select.Option;
const FormItem = Form.Item;
const { Search } = Input
var Token

class UserMD extends Component {
    constructor() {
        super();
        let RoleID = localStorage.getItem('RoleID')
        this.state = {
            dataUserMD: [],
            dataUser: [],
            datacompany: [],
            dataAD_site: [],
            dataRoleMD: [],
            dataObserveType: [],
            dataContractorcompany: [],
            datauserupdate: {},
            idupdate: null,
            User_Name: "",
            Password: "",
            UserFullName_ENG: "",
            UserFullName_TH: "",
            Email_Address: "",
            Email_Contact: "",
            CompanyID: "",
            Observer_Level: "",
            ObserverTypeID: "",
            Targetpermonth: "",
            Company: "",
            IsActived: false,
            RoleID: RoleID,
            ISCompanyAdmin: RoleID === '3',
            onLoading: false,
            onSentData: false,
            pop2: false,
            textSearch: ''
        }

        this.columns = [
            {
                title: 'No',
                dataIndex: 'PKUserID',
                width: 70,
                editable: true,
                fixed: 'left',
            },
            {
                title: 'User_Name',
                dataIndex: 'User_Name',
                editable: true,
                width: 150,
            },
            // {
            //     title: 'Password',
            //     dataIndex: 'Password',
            //     editable: true,
            //     width: 150,
            // },
            {
                title: 'UserFullName_ENG',
                dataIndex: 'UserFullName_ENG',
                editable: true,
                width: 300,
            },
            {
                title: 'UserFullName_TH',
                dataIndex: 'UserFullName_TH',
                editable: true,
                width: 300,
            },
            {
                title: 'Email_Address',
                dataIndex: 'Email_Address',
                editable: true,
                width: 300,
            },
            {
                title: 'Email_Contact',
                dataIndex: 'Email_Contact',
                editable: true,
                width: 300,
            },
            {
                title: 'CompanyID',
                dataIndex: 'CompanyID',
                editable: true,
                width: 100,
            },
            {
                title: 'CreateDate',
                dataIndex: 'CreateDate',
                editable: true,
                width: 150,
            },
            {
                title: 'UpdateDate',
                dataIndex: 'UpdateDate',
                editable: true,
                width: 150,
            },
            {
                title: 'UserCreate',
                dataIndex: 'UserCreate',
                editable: true,
                width: 150,
            },
            {
                title: 'UserUpdate',
                dataIndex: 'UserUpdate',
                editable: true,
                width: 150,
            },
            {
                title: 'ObserverTypeID',
                dataIndex: 'ObserverTypeID',
                editable: true,
                width: 150,
            },
            {
                title: 'Targetpermonth',
                dataIndex: 'Targetpermonth',
                editable: true,
                width: 100,
            },
            {
                title: 'RoleID',
                dataIndex: 'RoleID',
                editable: true,
                width: 150,
            },
            {
                title: 'Company',
                dataIndex: 'Company',
                editable: true,
            },
            {
                title: 'Status',
                dataIndex: 'IsActived',
                align: 'center',
                editable: true,
                render: (active) => (
                    <span>
                        <Tag color={active ? 'green' : 'volcano'} key={active}>
                            {active ? 'Active' : 'Inactive'}
                        </Tag>
                    </span>
                )
            },
            {
                title: "Edit",
                dataIndex: "Edit",
                width: 100,
                render: (text, record) => {
                    // console.log(record)
                    return record ? (
                        <a onClick={() => this.showupdate(record)}>Edit</a>
                    ) : null;
                }
            },
            {
                title: "Delete",
                dataIndex: "Delete",
                width: 150,
                render: (text, record) => {
                    return this.state.dataUserMD.length >= 1 ? (
                        <Popconfirm
                            title="Sure to delete?"
                            onConfirm={() => this.handleDelete(record.PKUserID)}
                        >
                            <a href="/">Delete</a>
                        </Popconfirm>
                    ) : null;
                }
            }
        ];
    }

    componentWillMount() {
        const axios = require('axios');
        this.setState({ onLoading: true })
        let userInfo = JSON.parse(window.localStorage.getItem('User_Info'))
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                Promise.all([this.getUser(),
                axios.get(
                    Odata_Url + 'OCompanyMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element) {
                        if ((userInfo.RoleID === 6 && userInfo.CompanyID == element.PKCompanyID) || userInfo.RoleID !== 6)
                            data.push(element);
                    });
                    //console.log(data);
                    this.setState({ datacompany: data })
                },
                    (error) => {
                        console.log(error);
                    }),
                axios.get(
                    Odata_Url + 'ORoleMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element) {
                        if ((element.PKRoleID === 5 && userInfo.RoleID === 5) || element.PKRoleID !== 5) {
                            data.push(element);
                        }
                    });
                    //console.log(data);
                    this.setState({ dataRoleMD: data, dataUser: data })
                },
                    (error) => {
                        console.log(error);
                    }),
                axios.get(
                    Odata_Url + 'OObserverTypeMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then((response) => {
                    const data = [];
                    response.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    //console.log(data);
                    this.setState({ dataObserveType: data })
                }, (error) => {
                    console.log(error);
                })]).then(() => {
                    this.setState({ onLoading: false })
                })
            }, (error) => {
                console.log(error)
                if (401 === error.response.status) {
                    window.location.href = "auth";
                }
            });
    }

    async getUser() {
        let userInfo = JSON.parse(window.localStorage.getItem('User_Info'))
        let url_user = 'OUserMD'
        if (localStorage.getItem('RoleID') === '3' || localStorage.getItem('RoleID') === '6') {
            url_user += `?$filter=CompanyID eq ${userInfo.CompanyID}`
        }
        return axios.get(Odata_Url + url_user, { headers: { "Authorization": "Bearer " + Token, } }).then((response) => {
            const data = [];
            response.data.value.forEach(function (element) {
                data.push(element);
            });
            this.setState({ dataUserMD: data, dataUser: data })
            return
        }, (error) => {
            console.log(error);
            return
        })
    }

    handleDelete = (id) => {
        const dataUserMD = this.state.dataUserMD;
        var data = dataUserMD.find(x => x.PKUserID === id)
        var state = JSON.parse(window.localStorage.getItem('state'))
        var UserID = state.authen.UserID
        data.CreateDate = data.CreateDate.slice(0, 19)
        data.UserUpdate = UserID

        this.getToken().then(token => {

            let tokenHeader = {
                headers: { "Authorization": "Bearer " + token }
            };

            axios.get(Constants.BASE_URL + 'api/User/DeleteUserMD?table=' + JSON.stringify(data), tokenHeader)
                .then((response) => {
                    this.setState({ textSearch: '' })
                    this.getUser();
                }, (error) => {
                    console.log(error);
                })
        });
    };

    showpop = () => {
        document.getElementById("pop1").style.display = "block";
    }
    handleCancel = () => {
        this.props.form.resetFields();
        document.getElementById("pop1").style.display = "none"
    }
    handleCancel2 = () => {
        this.props.form.resetFields();
        this.setState({ pop2: false })
    }
    handleSubmit_Add = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                var data = values
                data.User_Name = values.User_Name.replace(/ /g, "");
                data.UserID = window.localStorage.getItem("UserID")
                data.Targetpermonth = values.Targetpermonth == "" ? 0 : values.Targetpermonth

                this.getToken().then(token => {

                    let tokenHeader = {
                        headers: { "Authorization": "Bearer " + token }
                    };

                    axios.get(Constants.BASE_URL + 'api/User/PostSendingStatus?table=' + JSON.stringify(data), tokenHeader)
                        .then((response) => {
                            this.props.form.resetFields();
                            document.getElementById("pop1").style.display = "none"
                            window.location.reload();
                        },
                            (error) => {
                                console.log(error);
                            })
                });

                
            }
        });
    }
    handleSubmit_Put = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ onSentData: true })
                var data = this.state.datauserupdate
                var UserID = JSON.parse(window.localStorage.getItem('UserID'))
                let userInfo = JSON.parse(window.localStorage.getItem('User_Info'))
                data.User_Name = values.User_Name.replace(/ /g, "");
                data.Password = values.Password;
                data.UserFullName_ENG = values.UserFullName_ENG;
                data.UserFullName_TH = values.UserFullName_TH;
                data.Email_Address = values.Email_Address;
                data.Email_Contact = values.Email_Contact;
                data.CompanyID = values.CompanyID;
                data.Observer_Level = values.Observer_Level;
                data.ObserverTypeID = values.ObserverTypeID;
                data.Targetpermonth = values.Targetpermonth;
                data.Company = values.Company;
                data.DepartmentID = values.DepartmentID;
                data.RoleID = values.RoleID;
                data.CreateDateStr = data.CreateDate.slice(0, 19)
                data.CreateDate = null
                data.UpdateDate = null
                data.UserID = UserID;
                data.IsActived = values.Status;

                this.getToken().then(token => {

                    let tokenHeader = {
                        headers: { "Authorization": "Bearer " + token }
                    };

                    axios.get(Constants.BASE_URL + 'api/User/UpdateUserMD?table=' + JSON.stringify(data), tokenHeader).then((response) => {
                        this.getUser().then(() => {
                            this.setState({
                                onSentData: false,
                                pop2: false
                            })
                            this.props.form.resetFields()
                        })
                    }, (error) => {
                        console.log(error);
                        this.setState({ onSentData: false })
                    })
                });

                
            }
        });
    }
    showupdate = (record) => {
        var usermd = this.state.dataUserMD
        var data = usermd.find(x => x.PKUserID === record.PKUserID) || null
        this.setState({
            User_Name: record.User_Name,
            Password: record.Password,
            UserFullName_ENG: record.UserFullName_ENG,
            UserFullName_TH: record.UserFullName_TH,
            Email_Address: record.Email_Address,
            Email_Contact: record.Email_Contact,
            CompanyID: record.CompanyID,
            ObserverTypeID: record.ObserverTypeID,
            Targetpermonth: record.Targetpermonth,
            datauserupdate: data,
            RoleID: record.RoleID,
            idupdate: record.PKUserID,
            IsActived: record.IsActived,
            pop2: true
        })
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title
                })
            };
        });
        return (
            <div>
                <ScrollToTop />
                <Spin spinning={this.state.onSentData} size="large" className='spin' tip="Loading...">

                    <MenuSider title="User Management">

                        <div style={{ width: "100%", textAlign: "center", marginTop: "10px" }}>
                            <Search placeholder='Search by username, full name or email address' onSearch={value => {
                                let data = this.state.dataUserMD.filter(x => (x.User_Name || '').indexOf(value) > -1
                                    || (x.UserFullName_ENG || '').indexOf(value) > -1
                                    || (x.UserFullName_TH || '').indexOf(value) > -1
                                    || (x.Email_Address || '').indexOf(value) > -1)
                                this.setState({ dataUser: data })
                            }} style={{ width: '40%' }} value={this.state.textSearch} onChange={(e) => { this.setState({ textSearch: e.target.value }) }} />
                            <Button onClick={() => { this.setState({ dataUser: this.state.dataUserMD, textSearch: '' }) }} style={{ marginLeft: '10px' }}>Clear Search</Button>
                            {
                                !this.state.ISCompanyAdmin && (
                                    <Button
                                        onClick={this.showpop}
                                        style={{ marginBottom: 16, minWidth: "120px", backgroundColor: "rgb(0,152,139)", color: "white", marginLeft: '10px' }}
                                    >
                                        Add new data
                                    </Button>
                                )
                            }
                        </div>


                        <div id="pop1" className="popup">
                            <div className="popup-content animate">
                                <div style={{ margin: "15px" }}> Add new data </div>
                                <Form onSubmit={this.handleSubmit_Add}>
                                    {
                                        this.columns.map((l, i) => {
                                            if (l.title === "User_Name") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true, message: 'Please input ' + l.title,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Password") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "UserFullName_ENG") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true, message: 'Please input ' + l.title,
                                                                    }],
                                                                    initialValue: ''
                                                                })(

                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "UserFullName_TH") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true, message: 'Please input ' + l.title,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Email_Address") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Email_Contact") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "CompanyID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title}>
                                                                        {
                                                                            this.state.datacompany.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKCompanyID}>{l.Company_Name}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }

                                            if (l.title === "RoleID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title}>
                                                                        {
                                                                            this.state.dataRoleMD.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKRoleID}>{l.Role}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }

                                            if (l.title === "ObserverTypeID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: ''
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title}>
                                                                        {
                                                                            this.state.dataObserveType.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKObserverTypeID}>{l.ObserverType_Name}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Targetpermonth") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: 0
                                                                })(
                                                                    <InputNumber />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            return ('')
                                        })
                                    }
                                    <FormItem style={{ position: "relative", width: "50%", display: "inline-block", paddingLeft: "15px" }}>
                                        <Button onClick={() => this.handleCancel()} type="primary">
                                            Cancel
                                </Button>
                                    </FormItem>
                                    <FormItem style={{ position: "relative", width: "50%", float: "right", textAlign: "right", paddingRight: "15px" }}>
                                        <Button type="primary" htmlType="submit" >
                                            Submit
                                </Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                        <div id="pop2" className="popup" style={{ display: this.state.pop2 ? 'block' : 'none' }}>
                            <div className="popup-content animate">
                                <div style={{ margin: "15px" }}> Edit data </div>
                                <Form onSubmit={this.handleSubmit_Put}>
                                    {
                                        this.columns.map((l, i) => {
                                            if (l.title === "User_Name") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true, message: 'Please input ' + l.title,
                                                                    }],
                                                                    initialValue: this.state.User_Name
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Password") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false
                                                                    }],
                                                                    initialValue: this.state.Password
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "UserFullName_ENG") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: true, message: 'Please input ' + l.title,
                                                                    }],
                                                                    initialValue: this.state.UserFullName_ENG
                                                                })(

                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "UserFullName_TH") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.UserFullName_TH
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Email_Address") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.Email_Address
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Email_Contact") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.Email_Contact
                                                                })(
                                                                    <Input placeholder={'Please input ' + l.title} autosize={{ minRows: 1, maxRows: 3 }} disabled={this.state.ISCompanyAdmin} />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "CompanyID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.CompanyID
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title} disabled={this.state.ISCompanyAdmin}>
                                                                        {
                                                                            this.state.datacompany.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKCompanyID}>{l.Company_Name}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }

                                            if (l.title === "RoleID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.RoleID
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title} disabled={this.state.ISCompanyAdmin}>
                                                                        {
                                                                            this.state.dataRoleMD.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKRoleID}>{l.Role}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "ObserverTypeID") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.ObserverTypeID
                                                                })(
                                                                    <Select placeholder={"Please input" + l.title} disabled={this.state.ISCompanyAdmin}>
                                                                        {
                                                                            this.state.dataObserveType.map((l, i) => {
                                                                                return (
                                                                                    <Option value={l.PKObserverTypeID}>{l.ObserverType_Name}</Option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Targetpermonth") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem
                                                            label={l.title}
                                                        >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    initialValue: this.state.Targetpermonth
                                                                })(
                                                                    <InputNumber />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            if (l.title === "Status") {
                                                return (
                                                    <div style={{ margin: "15px" }}>
                                                        < FormItem label={l.title} >
                                                            {
                                                                getFieldDecorator(l.title, {
                                                                    rules: [{
                                                                        required: false,
                                                                    }],
                                                                    valuePropName: 'checked',
                                                                    initialValue: this.state.IsActived
                                                                })(
                                                                    <Switch checkedChildren='Active' unCheckedChildren='Inactive' />
                                                                )}
                                                        </FormItem >
                                                    </div>
                                                )
                                            }
                                            return ('')
                                        })
                                    }
                                    <FormItem style={{ position: "relative", width: "50%", display: "inline-block", paddingLeft: "15px" }}>
                                        <Button onClick={() => this.handleCancel2()} type="primary">
                                            Cancel
                                </Button>
                                    </FormItem>
                                    <FormItem style={{ position: "relative", width: "50%", float: "right", textAlign: "right", paddingRight: "15px" }}>
                                        <Button type="primary" htmlType="submit">
                                            Submit
                                </Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                        <Table
                            // components={components}
                            // rowClassName={() => "editable-row"}
                            // bordered
                            loading={this.state.onLoading}
                            dataSource={this.state.dataUser}
                            columns={columns}
                            scroll={{ x: 3000 }}
                        />
                    </MenuSider>
                </Spin>
            </div>
        )
    }
}

const WrappedUserMD = Form.create()(UserMD);

export default WrappedUserMD 
